import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgClockSometimesGlyphSecondary from './svgs/ClockSometimesGlyphSecondary.js';
import SvgClockSometimesGlyph from './svgs/ClockSometimesGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var clockSometimesGlyph = (props => useIcon(SvgClockSometimesGlyph, SvgClockSometimesGlyphSecondary, props));

export { clockSometimesGlyph as default };
